type Values = Record<string, string | number>;

export const convertValuesToNumbers = (values: Values) => {
  return Object.entries(values).reduce((acc, [key, value]) => {
    acc[key] = Number(value);
    return acc;
  }, {} as Values);
};
